export const cancel_exchange_order_confirm = `mutation cancel_exchange_order_confirm($secret: String!, $token: String!){
    cancel_exchange_order_confirm(secret: $secret, token: $token)
}`;
